module.exports = __webpack_public_path__ + "img/senhaseconfiguracoes.56109e56.jpg";